import axios from '@/plugins/axios'
import type { IAcademicYear, IAcademicYearStats, IAcademicYearProgrammeStats } from '@/interfaces/api-resources/Dara/AcademicYear'
import { useAppStore } from '@/stores/app'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return appStore.daraApiBaseUrl
  },

  getAcademicYearList(organisationId: number) {
    return axios.get<IAcademicYear[]>(this.baseUrl() + `/organisations/${organisationId}/academic-years`)
      .then(({ data }) => data)
  },

  getAcademicYearStats(academicYearId: number) {
    return axios.get<IAcademicYearStats, IAcademicYearStats>(this.baseUrl() + `/academic-years/${academicYearId}/statistics`)
      .then(response => response)
  },

  getAcademicYearProgrammeStats(academicYearId: number, programmeId: number) {
    return axios.get<IAcademicYearProgrammeStats, IAcademicYearProgrammeStats>(this.baseUrl() + `/academic-years/${academicYearId}/programme/${programmeId}/statistics`)
      .then(response => response)
  },

  updateAcademicYearAcknowledgement(academicYearId: number) {
    return axios.patch(this.baseUrl() + `/academic-years/${academicYearId}/acknowledge`)
  },
}
